module.exports = __webpack_public_path__ + "img/play.d1ef2827.png";